"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderScene = void 0;
// Some browsers (Safari) don't have good support for small fonts.
// Keep the font size constant and reduce the canvas scale to compensate.
var TEXT_SIZE = 100;
var isShadowValid = function (shadow) {
    return shadow.offsetX !== 0 || shadow.offsetY !== 0;
};
var drawImageToCanvas = function (ctx, frame, scale, imageSource, transform) {
    ctx.save();
    if (transform) {
        var imageWidth = imageSource.width;
        var imageHeight = imageSource.height;
        var imageAspect = imageWidth / imageHeight;
        var frameAspect = frame.width / frame.height;
        var fillWidth = frameAspect > imageAspect;
        var dw = fillWidth ? frame.width : frame.height * imageAspect;
        var dh = fillWidth ? frame.width / imageAspect : frame.height;
        var dx = fillWidth ? 0 : (frame.width - dw) * 0.5;
        var dy = fillWidth ? (frame.height - dh) * 0.5 : 0;
        ctx.scale(scale, scale);
        ctx.beginPath();
        ctx.rect(0, 0, frame.width, frame.height);
        ctx.clip();
        ctx.translate(frame.width * 0.5, frame.height * 0.5);
        ctx.translate(transform.position.x, transform.position.y);
        ctx.rotate((transform.rotation * Math.PI) / 180);
        ctx.scale(transform.scale, transform.scale);
        ctx.translate(frame.width * -0.5, frame.height * -0.5);
        ctx.drawImage(imageSource, 0, 0, imageWidth, imageHeight, dx, dy, dw, dh);
    }
    else {
        // Use transforms instead of target size to ensure high PDF quality (https://github.com/Automattic/node-canvas/issues/1462)
        ctx.scale((frame.width * scale) / imageSource.width, (frame.height * scale) / imageSource.height);
        ctx.drawImage(imageSource, 0, 0);
    }
    ctx.restore();
};
var createMaskedImage = function (_a) {
    var object = _a.object, scale = _a.scale, image = _a.image, mask = _a.mask, createCanvas = _a.createCanvas, transform = _a.transform;
    var width = object.frame.width * scale;
    var height = object.frame.height * scale;
    var frame = { x: 0, y: 0, width: width, height: height, rotation: 0 };
    var canvas = createCanvas(width, height);
    var ctx = canvas.getContext('2d');
    if (!ctx) {
        throw new Error('Failed to get canvas context');
    }
    drawImageToCanvas(ctx, frame, 1, mask);
    ctx.globalCompositeOperation = 'source-in';
    drawImageToCanvas(ctx, frame, 1, image, transform);
    return canvas;
};
var renderScene = function (_a) {
    var createCanvas = _a.createCanvas, ctx = _a.ctx, scene = _a.scene, scale = _a.scale, getImage = _a.getImage, getFont = _a.getFont, getTextLayout = _a.getTextLayout, resourceScale = _a.resourceScale, _b = _a.backgroundColor, backgroundColor = _b === void 0 ? 'white' : _b, textOnly = _a.textOnly, debugOverlay = _a.debugOverlay, hideObject = _a.hideObject, defaultFontUrls = _a.defaultFontUrls;
    ctx.fillStyle = backgroundColor;
    ctx.fillRect(0, 0, scene.width * scale, scene.height * scale);
    scene.objects.forEach(function (object) {
        var _a, _b;
        if (hideObject && hideObject(object)) {
            return;
        }
        ctx.save();
        var x = object.frame.x * scale;
        var y = object.frame.y * scale;
        var width = object.frame.width * scale;
        var height = object.frame.height * scale;
        if (object.frame.rotation !== 0) {
            var cx = width / 2;
            var cy = height / 2;
            ctx.translate(x + cx, y + cy);
            ctx.rotate((object.frame.rotation * Math.PI) / 180);
            ctx.translate(-cx, -cy);
        }
        else {
            ctx.translate(x, y);
        }
        switch (object.type) {
            case 'IMAGE': {
                if (textOnly) {
                    break;
                }
                var image = getImage(object.url);
                if (object.maskUrl) {
                    var mask = getImage(object.maskUrl);
                    image = createMaskedImage({
                        createCanvas: createCanvas,
                        object: object,
                        scale: scale * resourceScale,
                        image: image,
                        mask: mask,
                        transform: object.transform
                            ? __assign(__assign({}, object.transform), { position: {
                                    x: object.transform.position.x * scale,
                                    y: object.transform.position.y * scale,
                                } }) : undefined,
                    });
                    drawImageToCanvas(ctx, object.frame, scale, image);
                }
                else {
                    drawImageToCanvas(ctx, object.frame, scale, image, object.transform);
                }
                break;
            }
            case 'TEXT': {
                var font = getFont(object.fontUrl);
                var fontStack = __spreadArray([
                    font.fontFamily
                ], (defaultFontUrls
                    ? [
                        (_a = getFont(defaultFontUrls.emojis)) === null || _a === void 0 ? void 0 : _a.fontFamily,
                        (_b = getFont(defaultFontUrls.fallback)) === null || _b === void 0 ? void 0 : _b.fontFamily,
                    ]
                    : []), true).filter(Boolean)
                    .join(', ');
                var layout_1 = getTextLayout(object.id);
                var fontSize = layout_1.fontSize * scale;
                var textScale_1 = (scale * TEXT_SIZE) / fontSize;
                ctx.font = "".concat(TEXT_SIZE, "px ").concat(fontStack);
                ctx.save();
                ctx.scale(fontSize / TEXT_SIZE, fontSize / TEXT_SIZE);
                layout_1.fragments.forEach(function (fragment) {
                    var fragmentX = fragment.x * textScale_1;
                    var fragmentY = fragment.y * textScale_1;
                    var lineOffsetY = layout_1.lineOffsetY * textScale_1;
                    if (object.shadow && isShadowValid(object.shadow) && !textOnly) {
                        ctx.fillStyle = object.shadow.color;
                        ctx.fillText(fragment.text, object.shadow.offsetX * textScale_1 + fragmentX, object.shadow.offsetY * textScale_1 + fragmentY + lineOffsetY);
                    }
                    ctx.fillStyle = textOnly ? 'rgb(0, 0, 0)' : object.color;
                    ctx.fillText(fragment.text, fragmentX, fragmentY + lineOffsetY);
                    if (debugOverlay) {
                        ctx.strokeStyle = 'rgba(255, 0, 0, 0.5)';
                        ctx.lineWidth = 1;
                        ctx.strokeRect(fragmentX, fragmentY, fragment.width * textScale_1, layout_1.lineHeight * textScale_1);
                    }
                });
                ctx.restore();
                break;
            }
            case 'RECTANGLE': {
                ctx.fillStyle = object.fillColor;
                ctx.fillRect(0, 0, object.frame.width * scale, object.frame.height * scale);
                if (object.outline) {
                    ctx.strokeStyle = object.outline.color;
                    ctx.lineWidth = object.outline.width * scale;
                    ctx.strokeRect(0, 0, object.frame.width * scale, object.frame.height * scale);
                }
            }
        }
        if (debugOverlay) {
            ctx.strokeStyle = 'rgb(0, 255, 0)';
            ctx.lineWidth = 1;
            ctx.strokeRect(0, 0, width, height);
        }
        ctx.restore();
    });
};
exports.renderScene = renderScene;
